import type { TimelineEventCard } from '../../games/playtest-sessions-data.js';

interface Props {
  card: TimelineEventCard;
}

export function SessionEventCard({ card }: Props): JSX.Element {
  const hasPayload = Object.keys(card.eventLog.payload).length > 0;
  const title = card.eventLabel === '' ? card.eventLog.eventName : card.eventLabel;
  return (
    <div className="flex flex-col gap-1.5 rounded-md border border-border bg-surface px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="rounded-sm border border-border bg-surface-2 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-text-muted">
            Event
          </span>
          <span className="text-sm text-text">{title}</span>
        </div>
        <span className="text-xs text-text-muted">{formatTime(card.at)}</span>
      </div>
      <div className="text-xs text-text-muted">
        <code className="rounded-sm bg-surface-2 px-1 py-0.5 font-mono">{card.eventLog.eventName}</code>
      </div>
      {hasPayload ? (
        <details className="text-xs text-text-muted">
          <summary className="cursor-pointer text-text">Payload</summary>
          <pre className="mt-1 max-h-48 overflow-auto rounded-sm border border-border bg-surface-2 p-2 font-mono text-[11px] text-text">
            {JSON.stringify(card.eventLog.payload, null, 2)}
          </pre>
        </details>
      ) : null}
    </div>
  );
}

function formatTime(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleString();
}
